export enum KeyCodes {
  minus = 'Minus',
  equal = 'Equal',
  numpadAdd = 'NumpadAdd',
  numpadSubtract = 'NumpadSubtract',
  digit0 = 'Digit0',
}
